import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "home_38dah",
  "use": "home_38dah-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"home_38dah\">\n    <rect x=\"3\" y=\"3\" width=\"7\" height=\"7\" stroke=\"currentColor\" fill=\"none\" />\n    <rect x=\"14\" y=\"3\" width=\"7\" height=\"4\" stroke=\"currentColor\" fill=\"none\" />\n    <rect x=\"14\" y=\"10\" width=\"7\" height=\"4\" stroke=\"currentColor\" fill=\"none\" />\n    <rect x=\"3\" y=\"14\" width=\"18\" height=\"7\" stroke=\"currentColor\" fill=\"none\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol